import { tokens } from '@/modules/utils/themeUtils';
import {
  Breakpoints,
  styled,
} from '@volkswagen-onehub/components-core';

export const StyledWrapper = styled.div(
  ({ theme }) => `
  background: ${tokens.globalColors.vLightGrey};
  width: 100%;
  padding: ${theme.size.static450};

  @media (min-width: ${Breakpoints.b1280}px) {
    padding: ${theme.size.static530} ${theme.size.static750};
  }
`
);

export const StyledColumnWrapper = styled.div`
  display: flex;
  flex-direction: column;

  @media (min-width: ${Breakpoints.b1280}px) {
    flex-direction: row;
  }
`;

export const StyledFooterBackToTopWrapper = styled.div(
  ({ theme }) => `
  margin-bottom: ${theme.size.static300};

  @media (min-width: ${Breakpoints.b1280}px) {
    display: flex;
    justify-content: center;
    margin-bottom: ${theme.size.static515};
  }
`
);

export const StyledColumn1 = styled.div(
  ({ theme }) => `
  padding-bottom: ${theme.size.static450};
  position: relative;

  :after {
    content: '';
    position: absolute;
    right: 0;
    bottom: 0;
    left: 0;
    height: 1px;
    border-bottom: 1px solid ${theme.colors.border.default};
  }

  @media (min-width: ${Breakpoints.b1280}px) {
    padding: 0 ${theme.size.static750} 0 0;
    width: 50%;

    :after {
      content: '';
      position: absolute;
      right: 0;
      top: 0;
      bottom: 0;
      width: 1px;
      border-right: 1px solid ${theme.colors.border.default};
    }
  }
`
);

export const StyledColumn2 = styled.div(
  ({ theme }) => `
  padding-top: ${theme.size.static450};

  @media (min-width: ${Breakpoints.b1280}px) {
    padding: 0 0 0 ${theme.size.static750};
    margin-left: -1px;
    position: relative;
    width: 50%;

    :before {
      content: '';
      position: absolute;
      left: 0;
      top: 0;
      bottom: 0;
      width: 1px;
      border-left: 1px solid ${theme.colors.border.default};
    }
  }
`
);

interface StyledFooterModelLinksProps {
  single?: boolean;
}

export const StyledFooterModelLinks = styled.div<StyledFooterModelLinksProps>(
  ({ single, theme }) => `
  gap: ${theme.size.static150};
  display:grid;

  @media (min-width: ${Breakpoints.b1280}px) {
    gap: ${theme.size.static400};
    ${
      !single &&
      `display:grid;
      grid-auto-columns:1fr;
      grid-auto-flow:column;`
    }
  }
`
);
